"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTable = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
const computeStyledMargins_1 = require("../../general/utility/computeStyledMargins");
exports.StyledTable = styled_components_1.default.table `
  background: ${config_1.colors.white};
  border-radius: 0 0 8px 8px;
  display: inline-table;
  margin-bottom: 0;

  ${computeStyledMargins_1.computeStyledMargins}
`;
